import React from "react"
import { getByCategory } from "../service/post"
import { get } from "lodash"
import { Block } from "baseui/block"
import TrueCIBar from "./TrueCIBar"
import CategoryTabs from "../components/CategoryTabs"
import { H2, H3 } from "baseui/typography"
import PostCollection from "../components/PostCollection"
import { Button, SHAPE } from "baseui/button"
import HighlightBanner from "../components/HighlightBanner"
import SEO from "../components/seo"

type PostListByCategoryRendererTemplateProps = {
  pageContext: {
    category: string
    posts: any[]
    count: number
    highlightBanner: {
      banners: any[]
    }
    seo: {
      siteTitle: string
      title: string
      keywords: string[]
      description: string
      ogImage: string
    }
  }
}

const PostListByCategoryRendererTemplate = ({
  pageContext,
}: PostListByCategoryRendererTemplateProps) => {
  const {
    posts,
    category,
    highlightBanner,
    seo: { title, keywords, description, ogImage, siteTitle },
  } = pageContext

  const shelfBottomMargin = ["20px", "20px", "40px", "40px"]
  const shelfTopMargin = ["30px", "30px", "30px", "30px"]

  const [postsData, setPostsData] = React.useState(posts)
  const [isFetching, setIsFetching] = React.useState(false)
  const [count, setCount] = React.useState(0)

  React.useEffect(() => {
    getCount()
  }, [])

  const getCount = async () => {
    const data = await getByCategory(category, 0, 1)
    setCount(get(data, "data.data.count", 0))
  }

  const fetchPost = async () => {
    setIsFetching(true)
    const data = await getByCategory(category, postsData.length, 9)
    const newPosts = get(data, "data.data.items", [])
    setCount(get(data, "data.data.count", 0))
    setPostsData(postsData => [...postsData, ...newPosts])
    setIsFetching(false)
  }

  return (
    <>
      <SEO
        siteTitle={siteTitle}
        title={title}
        description={description}
        ogImage={ogImage}
        keywords={keywords}
      />
      <HighlightBanner
        banners={
          highlightBanner && highlightBanner.banners
            ? highlightBanner.banners
            : []
        }
      />
      {/* <TrueCIBar /> */}
      <Block
        $style={{
          background: `url(${require("../images/content_BG.png")}) top/cover no-repeat`,
        }}
        paddingTop={shelfTopMargin}
        paddingBottom={shelfBottomMargin}
      >
        <Block
          maxWidth={"1600px"}
          width={"95%"}
          marginLeft={"auto"}
          marginRight={"auto"}
          display={"flex"}
          flexDirection={"column"}
        >
          <CategoryTabs category={category} />
          <H2
            marginTop={"40px"}
            marginBottom={["24px", "30px", "30px", "30px"]}
            marginLeft={["0px", "8px", "10px", "10px"]}
            color={"white"}
            alignSelf={["center", "flex-start", "flex-start", "flex-start"]}
          >
            What's New
          </H2>
          {postsData.length > 0 ? (
            <PostCollection posts={postsData} allPostStyle />
          ) : (
            <Block
              backgroundColor={"#2C2D2F"}
              display={"flex"}
              justifyContent={"center"}
              alignItems={"center"}
              minHeight={"24vh"}
              overrides={{
                Block: {
                  style: ({ $theme }) => ({
                    borderRadius: "4px",
                    boxShadow: $theme.lighting.shadow400,
                    textAlign: "center",
                  }),
                },
              }}
            >
              <H3 color={"white"}>No Content</H3>
            </Block>
          )}
          {postsData.length < count && (
            <Block width={["80%", "30%", "20%", "20%"]} margin={"auto"}>
              <Button
                shape={SHAPE.pill}
                isLoading={isFetching}
                $style={{ width: "100%" }}
                onClick={() => {
                  fetchPost()
                }}
              >
                Load More
              </Button>
            </Block>
          )}
        </Block>
      </Block>
    </>
  )
}

export default PostListByCategoryRendererTemplate
